import { getBaseCustomProps, getFormCustomProps } from '../../Utilities/types/SharedProps';
import { getHTMLAttributes } from '../../Utilities/utils/Funtions/data-aria-attrs';
import {
	TextareaBaseStyle,
	TextareaBaseFontStyle,
	TextareaEpoCustoms,
	TextareaDisabledInputStyles,
	TextareaInputResizable,
	TextareaSpacing,
} from './styles';
import * as meta from '../../meta-data.json';
import { marginSize, paddingSize } from '../../Utilities/utils/Theming';

export const overrides = (props: any, disabled: any) => {
	const HTMLAttrs = getHTMLAttributes(props);
	const {
		autoFocus,
		onFocus,
		onBlur,
		inputRef,
		children,
		resizable,
		error,
		positive,
		overrides,
		clearable,
		...rest
	} = HTMLAttrs.rest;
	const { warning } = props;

	return {
		/**
		 * Baseui v10.3.0 added the Root on the textarea and
		 * the content is pushed on the right and it breaks
		 * the normal behaviour - see DES-1228
		 */
		Root: {
			style: {
				borderTopWidth: '0',
				borderRightWidth: '0',
				borderBottomWidth: '0',
				borderLeftWidth: '0',
				backgroundColor: 'transparent',
				...marginSize('0', '0', '0', '0'),
				...paddingSize('0', '0', '0', '0'),
				overflow: 'visible',
			},
		},
		Input: {
			props: {
				...getFormCustomProps(props),
				...HTMLAttrs.ariaProps,
				...rest,
				name: props.name,
				tabIndex: props.tabIndex || 0,
				readOnly: props.readOnly ? 'readonly' : undefined,
			},
			style: ({ $theme, $disabled }: any) => {
				return {
					// Colors and status
					...TextareaInputResizable(props),
					...(TextareaBaseFontStyle($theme, props) as any),
					...TextareaDisabledInputStyles($theme, $disabled || disabled),
					// Spacing and sizes
					...TextareaSpacing($theme, props),
				};
			},
		},
		InputContainer: {
			props: {
				...getBaseCustomProps(props),
				...HTMLAttrs.dataProps,
				className: props.className,
				'data-epo': `epo-textarea-${meta.version}`,
				part: `epo-textarea-${meta.version}`,
				key: props.key,
				tabIndex: props.tabIndex || 0,
			},
			style: ({ $theme, $isFocused, $error, $positive }: any) => {
				return {
					// Colors and status
					...TextareaBaseFontStyle($theme, props),
					...TextareaBaseStyle($theme, props, $isFocused),
					...TextareaEpoCustoms({ $theme, $isFocused, $error, $positive, warning }, props),
				};
			},
		},
	};
};
